import { render, staticRenderFns } from "./choseQuestion.vue?vue&type=template&id=5aef65d2&scoped=true&"
import script from "./choseQuestion.vue?vue&type=script&lang=js&"
export * from "./choseQuestion.vue?vue&type=script&lang=js&"
import style0 from "./choseQuestion.vue?vue&type=style&index=0&id=5aef65d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aef65d2",
  null
  
)

export default component.exports